import { PageDataProvider } from './core/page-data';
import { ErrorFallback } from 'components/errors/error-boundary';
import { AsideDefault } from 'components/layout/aside/aside-default';
import { Content } from 'components/layout/content';
import { Footer } from 'components/layout/footer';
import { HeaderWrapper } from 'components/layout/header/header-wrapper';
import { MenuComponent } from 'components/layout/menu';
import { ScrollTop } from 'components/layout/scroll-to-top';
import { useEffect } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { Outlet, useLocation } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';

const logError = (error: Error, info: { componentStack: string }) => {
  console.log(`Error: ${error}  Stack: ${info.componentStack}`);
};

const MasterLayout = () => {
  const location = useLocation();
  useEffect(() => {
    setTimeout(() => {
      MenuComponent.reinitialization();
    }, 500);
  }, []);

  useEffect(() => {
    setTimeout(() => {
      MenuComponent.reinitialization();
    }, 500);
  }, [location.key]);

  return (
    <PageDataProvider>
      <div className="d-flex flex-column flex-root">
        {/* begin::Page */}
        <div className="page d-flex flex-row flex-column-fluid">
          <AsideDefault />
          {/* begin::Wrapper */}
          <div className="wrapper d-flex flex-column flex-row-fluid" id="kt_wrapper">
            <HeaderWrapper />

            {/* begin::Content */}
            <div id="kt_content" className="content d-flex flex-column flex-column-fluid">
              <ErrorBoundary FallbackComponent={ErrorFallback} onError={logError}>
                <Content>
                  <Outlet />
                </Content>
              </ErrorBoundary>
            </div>
            {/* end::Content */}
            <Footer />
          </div>
          {/* end::Wrapper */}
        </div>
        {/* end::Page */}
      </div>

      {/* begin:: Drawers */}
      {/* end:: Drawers */}

      {/* begin:: Modals */}
      {/* end:: Modals */}
      <ScrollTop />
      <ToastContainer autoClose={2000} theme="light" />
    </PageDataProvider>
  );
};

export { MasterLayout };
